type WP = { w: number; h: number };

export function getWidgetOverviewSize(pos: WP) {
  if (pos.w === 2 && pos.h === 1) {
    return "TWO_X_ONE";
  }

  if (pos.w === 2 && pos.h === 2) {
    return "TWO_X_TWO";
  }
  if (pos.w === 2 && pos.h === 3) {
    return "TWO_X_THREE";
  }
  if (pos.w === 2 && pos.h === 4) {
    return "TWO_X_FOUR";
  }

  return null;
}

export function getWidgetIntegrationTurnpikeSize(pos: WP) {
  if (pos.w === 2 && pos.h === 1) {
    return "TWO_X_ONE";
  }
  if (pos.w === 2 && pos.h === 2) {
    return "TWO_X_TWO";
  }

  return null;
}

export function getWidgetNoteSize(pos: WP) {
  if (pos.w === 2 && pos.h === 1) {
    return "TWO_X_ONE";
  }
  if (pos.w === 2 && pos.h === 2) {
    return "TWO_X_TWO";
  }

  return null;
}
export function getTaskSingleSize(pos: WP) {
  if (pos.w === 1 && pos.h === 1) {
    return "ONE_X_ONE";
  }
  if (pos.w === 2 && pos.h === 1) {
    return "TWO_X_ONE";
  }

  return null;
}

export function getWeatherSize(pos: WP) {
  if (pos.w === 1 && pos.h === 1) {
    return "ONE_X_ONE";
  }
  if (pos.w === 2 && pos.h === 1) {
    return "TWO_X_ONE";
  }

  return null;
}
